export const getBaseUrlParams = () => {
  const url = window.location.href;

  const organizationIdMatch = url.match(/organizations\/(\d+)/);

  const organization_id = organizationIdMatch ? organizationIdMatch[1] : null;
  const searchParams = new URL(url).searchParams;

  const short_url = searchParams.get("short_url");

  return {
    organization_id,
    short_url
  };
};
